import { sanitizeCondition } from './sanitizeCondition';
import { sanitizeRequiredChildren } from './helpers';
function sanitizeOptionalChildren(raw, sanitizeElement) {
  if (!Array.isArray(raw)) return undefined;
  const children = raw.map(sanitizeElement).filter(c => c !== null);
  return children.length > 0 ? children : undefined;
}
export function sanitizeIf(el, sanitizeElement) {
  const condition = sanitizeCondition(el.condition);
  if (!condition) return null;
  const children = sanitizeRequiredChildren(el.children, sanitizeElement);
  if (!children) return null;
  const elseBranch = sanitizeOptionalChildren(el.else, sanitizeElement);
  return Object.assign({
    type: 'If',
    condition,
    children
  }, elseBranch && {
    else: elseBranch
  });
}